// 注意，所有使用ListWrap组件的组件都需要经过这一层循环
// sku与ssu统一格式化
export const calcGoodsList = skus => {
  let skusData = []
  if (skus && Array.isArray(skus)) {
    skusData = skus
  }
  return skusData.map(sku => {
    // 精品推荐的数据
    sku.isRecommend = !!sku.trail_info
    // 试点推荐数据
    sku.isTrialRecommend = sku.trail_info && sku.trail_info.is_recommend
    sku.labels = sku.labels || []
    // 是否存在会员价ssu
    const promote_type = sku.promote_type || [] // eslint-disable-line camelcase
    sku.hasMemberPrice = promote_type.includes(12)
    sku.hasPromote = judgeHasPromote(promote_type)
    // 组织ssu数据
    ;(sku.ssu_list || []).forEach(ssu => formatSsu(ssu))
    if (sku.ssu_list && sku.ssu_list.length > 1) {
      Object.assign(sku, {
        isSingle: false,
        isCombined: false
      })
    } else {
      const ssu = { ...sku.ssu_list[0] }
      Object.assign(sku, {
        isSingle: true,
        isCombined: Number(ssu.activity_type) === 6,
        ssu
      })
    }
    return sku
  })
}

// 格式化ssu
export const formatSsu = ssu => {
  const promotion_remind_info = ssu.promotion_remind_info || {} // eslint-disable-line camelcase
  const promote_type = promotion_remind_info.promote_type || [] // eslint-disable-line camelcase
  ssu.isMemberPrice = promote_type.includes(12) // 是否展示会员价（价钱颜色改变），目前不再使用
  ssu.hasPromote = judgeHasPromote(promote_type) // 促销
  return ssu
}

// 是否包含促销
// eslint-disable-next-line camelcase
export const judgeHasPromote = promote_type => {
  // eslint-disable-line camelcase
  promote_type = promote_type || [] // eslint-disable-line camelcase
  return (
    promote_type.includes(2) || // 普通商品2和购物车3是一个东西
    promote_type.includes(3) ||
    promote_type.includes(4) ||
    promote_type.includes(21) || // 会员价（标签展示），新增类型
    promote_type.includes(12)
  ) // 会员 目前不再使用
}
